export default __webpack_public_path__ + "static/media/banner-governing-council.580fb7dd.webp";